import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MerakisService } from '@app/features/merakis/shared/merakis.service';
import { MerakiNetwork } from '@app/shared/models/meraki/meraki-network.model';
import { MatOptionSelectionChange } from '@angular/material/core';

@Component({
    selector: 'app-meraki-network-form',
    templateUrl: './network-form.component.html',
    styleUrls: ['./network-form.component.css'],
    standalone: false
})
export class MerakiNetworkFormComponent implements OnInit, OnDestroy {
    isLoading: boolean = false;
    networkForm: UntypedFormGroup;
    configTemplates = [];
    network: MerakiNetwork;
    selectedConfigTemplateId: string;

    constructor(private merakiService: MerakisService) { }
    ngOnInit() {
        this.isLoading = true;
        this.getConfigTemplates();
        this.networkForm = new UntypedFormGroup(
            {
                "name": new UntypedFormControl(null, [
                    Validators.required,
                    Validators.maxLength(5),
                    Validators.minLength(5),
                    Validators.pattern("^[0-9]*$")
                ]),
                "tags": new UntypedFormControl(null, [
                    Validators.required
                ]),
                "type": new UntypedFormControl({
                    value: "switch",
                    disabled: true
                },
                    [
                        Validators.required
                    ]),
                "template": new UntypedFormControl(null, [
                    Validators.required
                ])
            }
        );
        this.isLoading = false;
    }
    ngOnDestroy() { }

    getConfigTemplates() {
        const promise = new Promise((resolve, reject) => {
            this.merakiService.getConfigTemplates().then(response => {
                response.toPromise().then(configTemplateFromResponse => {
                    try {
                        configTemplateFromResponse["message"].forEach(configTemplateJson => {
                            let template = configTemplateJson;
                            this.configTemplates.push(template);
                        });
                    } catch (error) {
                        console.log("Config templates timed out!")
                    } finally {
                        resolve(true);
                    }
                });
            });
        });

        return promise;
    }

    createNetwork(): Promise<MerakiNetwork> {
        this.isLoading = true;
        const promise = new Promise<MerakiNetwork>((resolve, reject) => {
            this.merakiService.createNetwork(
                this.networkForm.get('name').value,
                this.networkForm.get('type').value,
                this.networkForm.get('tags').value
            ).then(response => {
                response.toPromise().then(network_from_response => {
                    try {
                        let network: MerakiNetwork = network_from_response["message"];
                        this.network = network;
                    } catch (error) {
                        console.log("Create Meraki network timed out!")
                    } finally {
                        resolve(this.network);
                        this.isLoading = false;
                    }
                });
            });
        });

        return promise;
    }

    bindNetwork(networkId: string) {
        this.isLoading = true;
        const promise = new Promise((resolve, reject) => {
            this.merakiService.bindNetwork(
                networkId,
                this.selectedConfigTemplateId
            ).then(response => {
                response.toPromise().then(network_from_response => {
                    try {
                        let network: MerakiNetwork = network_from_response["message"];
                        this.network = network;
                    } catch (error) {
                        console.log("Bind Meraki network timed out!")
                    } finally {
                        resolve(true);
                        this.isLoading = false;
                    }
                });
            });
        });

        return promise;
    }

    handleConfigTemplateSelection(event: MatOptionSelectionChange) {
        this.selectedConfigTemplateId = event.source.value;
    }

    clear() {
        this.networkForm.reset();
    }

}